import { Site } from '@/types';
import { RouterHelper } from '../router';
import store from '../store/store';

export class SiteMutator {
  public static toTabular(site: Site, config: any): any {
    const tableConfig: any = {
      site: {
        value: site.name,
        property: 'site.name',
        navigateTo: `/site/${site.id}`,
      },
      address: {
        value: site.address,
        property: 'site.address',
        align: 'left',
      },
      locations: {
        value: site.locations_total,
        property: 'site.locations_total',
        align: 'center',
      },
      devices: {
        value: site.devices_total,
        property: 'stage.devices_total',
        align: 'center',
      },
      id: site.id,
    };

    if (config && config.exclude) {
      (config.exclude as string[]).forEach((value) => delete tableConfig[value]);
    }

    return tableConfig;
  }
}
